import React, { useState } from "react";
import { Stack } from "@mui/material";
import {
  Container,
  InputLabel,
  InputTextField,
  SubmitButton,
  Title,
} from "./resetPassword.components";
import { useAlert } from "react-alert";
import { homepage, loginLink } from "../../../common/routes";
import { useLocation, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { resetPassword } from "../../../services/auth";

function ResetPassword() {
  const alert = useAlert();
  const navigate = useNavigate();
  const [cookies] = useCookies();
  const { state } = useLocation();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  if (cookies.token !== undefined && cookies.token !== "undefined")
    navigate(homepage);
  if (state === null) navigate(loginLink);

  const handleResetPassword = async () => {
    if (!password) {
      alert.error("please enter the password");
      return;
    }
    if (password !== confirmPassword) {
      alert.error("passwords do not matchs");
      return;
    }

    const resetPasswordData = {
      emailID: state.emailID,
      otp: state.otp,
      password: password,
    };
    await resetPassword(resetPasswordData)
      .then((response) => {
        if (response.status !== 200) {
          alert.error(response.data.message);
          return;
        }
        alert.success(response.data.message);
        navigate(loginLink);
      })
      .catch((error) => console.log(error));
  };

  return (
    <Container>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="flex-start"
        spacing={2.5}
        sx={{ py: 5.75, width: 480, m: "auto" }}
      >
        <Title>Set new Password</Title>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          spacing={2}
        >
          <InputLabel>New Password</InputLabel>
          <InputTextField
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
          />
        </Stack>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          spacing={2}
        >
          <InputLabel>Confirm Password</InputLabel>
          <InputTextField
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            type="password"
          />
        </Stack>
        <SubmitButton onClick={handleResetPassword}>Confirm</SubmitButton>
      </Stack>
    </Container>
  );
}

export default ResetPassword;
